import React from 'react';
import {convertTimeCreditToPcBangPoint, convertTimeCreditToTimeFormat} from '../../util/timeUtils';
import commaNumber from 'comma-number';
import {Table} from '../Common/PageComponents';

export const ProductsTable = ({products, style, className}) => {
  return (
    <Table theme="special" style={style} className={className}>
      <thead>
        <tr>
          <th>가격 (부가세 포함)</th>
          <th>구매포인트</th>
          <th>보너스비율</th>
          <th>LoL 기준 사용시간 환산</th>
          <th>게임별 포인트당 사용시간</th>
        </tr>
      </thead>
      <tbody style={{textAlign: 'center'}}>{renderProduct(products)}</tbody>
    </Table>
  );
};

const renderProduct = productsObject => {
  const products = productsObject && Object.values(productsObject);
  return products
    .sort((a, b) => a.price - b.price)
    .map((product, idx) => {
      const pcBangPoint = convertTimeCreditToPcBangPoint(product.timeCredit);
      const discountRate =
        idx === 0 ? '-' : `${(parseInt(pcBangPoint.replace(',', '')) / product.price - 1).toFixed(4) * 100} %`;
      return (
        <tr key={product.price}>
          <td>{commaNumber(product.price)} 원</td>
          <td>{pcBangPoint}</td>
          <td>{discountRate}</td>
          <td>{convertTimeCreditToTimeFormat(product.timeCredit).replace('0분 0초', '')}</td>
          {idx === 0 && (
            <td rowSpan={products.length}>
              <div>리그 오브 레전드 15.45초/pt</div>
              <br />
              <div>발로란트 14.07초/pt </div>
            </td>
          )}
        </tr>
      );
    });
};
